import { render } from "./MultiJsonInput.vue?vue&type=template&id=4d076f10&ts=true"
import script from "./MultiJsonInput.vue?vue&type=script&lang=ts"
export * from "./MultiJsonInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__